import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="dependent-checkboxes"
export default class extends Controller {
  static targets = ['checkbox']
  connect () {
  }

  updateDependentCheckboxes (event) {
    const id = String(event.params.id)
    const parentCheckbox = this.checkboxTargets.find(c => c.dataset.dependentCheckboxesId === id)

    this.checkboxTargets.filter(checkbox => {
      return checkbox.dataset.dependentCheckboxesParentId === id
    }
    ).forEach(checkbox => {
      checkbox.checked = parentCheckbox.checked
      checkbox.dispatchEvent(new Event('change'))
    })
  }
}
